module.exports = __webpack_public_path__ + "static/media/features2.ce86a5b7.png";